const toLower = (v) => typeof v == "string" ? v.toLowerCase() : "" + v;
const getDateByKey = (date, key) => {
  switch (key) {
    case "year":
      return +date.slice(0, 4);
    case "month":
      return +date.slice(5, 7);
    case "day":
      return +date.slice(8, 10);
    case "hour":
      return +date.slice(11, 13);
    case "minute":
      return +date.slice(14, 16);
  }
};
const matchNumber = (v) => v.match(/^\d+$/);
const matchFloat = (v) => v.match(/^-?\d+(\.\d+)?$/);
const matchDate = (v) => v.match(/^\d{4}(-\d{2}(-\d{2})?)?$/);
const basename = (file) => {
  const pos = file.lastIndexOf("/");
  return pos >= 0 ? file.substring(pos + 1) : file;
};
const dirname = (file) => {
  const pos = file.lastIndexOf("/");
  return pos >= 0 ? file.substring(0, pos) : "";
};
const ext = (file) => {
  const pos = file.lastIndexOf(".");
  return pos >= 0 ? file.substring(pos + 1) : file;
};
export {
  basename,
  dirname,
  ext,
  getDateByKey,
  matchDate,
  matchFloat,
  matchNumber,
  toLower
};
//# sourceMappingURL=utils.js.map
